<ng-template [ngIf]="isGallery" [ngIfElse]="magazine">
  <app-gallery-root></app-gallery-root>
</ng-template>
<ng-template #magazine>
  <app-magazine-root></app-magazine-root>
</ng-template>
